import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  ViewChild,
} from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { CommonService } from '../../../../shared/services/common.service'
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms'
import { Observable } from 'rxjs'
import { ICON_TYPE } from '@spartacus/storefront'
import {
  GlobalMessageEntities,
  GlobalMessageType,
  GlobalMessageService,
} from '@spartacus/core'
@Component({
  standalone: false,
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit {
  public infoMsg = false

  myprofile: FormGroup
  myprofiledetails: FormGroup
  myprofilenotify: FormGroup
  personaldetail: FormGroup
  iconTypes = ICON_TYPE
  // @ViewChild("defaultOpen", {static: false}) defaultOpen: ElementRef;

  messages$: Observable<GlobalMessageEntities>
  messageType: typeof GlobalMessageType = GlobalMessageType
  displayRoleMatrix: boolean = false

  constructor(protected globalMessageService: GlobalMessageService) {}
  openProduct(evt, prodName) {
    //this.clear(this.messageType.MSG_TYPE_CONFIRMATION, 1);
    var i, tabcontent, tablinks
    tabcontent = document.getElementsByClassName('tabcontent')
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none'
    }
    tablinks = document.getElementsByClassName('tablinks')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '')
    }
    //  this.renderer.setStyle(this.category.nativeElement, 'display', 'block');
    document.getElementById(prodName).style.display = 'block'
    evt.currentTarget.className += ' active'
  }
  clear(type: GlobalMessageType): void {
    this.globalMessageService.remove(type)
  }

  ngOnInit(): void {
    this.messages$ = this.globalMessageService.get()
    this.messages$.subscribe((result) => {})
    // this.defaultOpen.nativeElement.click();
    document.getElementById('defaultOpen').click()
  }

  rolesMatrixDisplay(event) {
    if (event === 'true') {
      this.displayRoleMatrix = true
    } else {
      this.displayRoleMatrix = false
    }
  }

  closeRolesMatrixOverlay(event) {
    this.displayRoleMatrix = false
  }
}
